<!-- desktop view -->
<div class="container-fluid mb-3 hidden md:block" style="margin-top:55px;">
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="bg-white pt-3 pb-3">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <h5 class="section-header mb-2">DOCUMENTS</h5>
                        </div>
                    </div>
                </div>
                <div *ngIf="dataExists === true">
                    <div class="container-fluid" style="background-color: #f8f8f8; padding-top:0">
                        <div class="row custom-card p-3 pb-2">
                            <div class="col-3">
                                <h6>Title</h6>
                            </div>
                            <div class="col-3">
                                <h6>Description</h6>
                            </div>
                            <div class="col-3">
                                <h6>Date uploaded</h6>
                            </div>
                            <div class="col-3">
                                <h6>Action</h6>
                            </div>
                        </div>
                    </div>
                    <div class="container-fluid" style="padding-top:0">
                        <div class="row">
                            <div class="col-12">
                                <div class="container-fluid">
                                    <div class="row custom-card mb-2 animated fadeInUp" *ngFor="let doc of doclist"
                                        style="border-radius: 3px">
                                        <div class="col-3 p-3">{{ doc.title }}</div>
                                        <div class="col-3 p-3">{{ doc.description }}</div>
                                        <div class="col-3 p-3">{{ doc.date_uploaded }}</div>
                                        <div class="col-3 p-3">
                                            <button mat-raised-button class="mr-2" (click)="showImage(doc)"
                                                title="view"><mat-icon>visibility</mat-icon></button>
                                            <!-- <button mat-raised-button  (click)="deleteImage(doc)" title="delete"><mat-icon>delete</mat-icon></button> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pl-3" *ngIf="dataExists === false">
                    <p>{{_data}}</p>
                </div>
            </div>

        </div>
    </div>
</div>

<nav class="navbar navbar-expand-sm fixed-bottom">
    <ul class="navbar-nav ml-auto">
        <button type="button" matTooltip="Add document" mat-button class="mat-fab" color="primary"
            (click)="addDocument()"><mat-icon>add</mat-icon></button>

    </ul>
</nav>